import React from 'react';
import { useSelector } from 'react-redux';
import Loading from 'components/World/Loading';

/**
 * Global loading overlay that renders at the App level.
 * This ensures it appears above ALL other components including
 * SpeechToTextService/LiveKitTextInput which are also at the App level.
 *
 * Skipped for screens that don't use the Unity world (e.g. lessonViewer).
 */
const SCREENS_WITHOUT_WORLD = ['lessonViewer'];

const GlobalLoadingOverlay = () => {
  const worldLoading = useSelector(state => state.world.worldLoading);
  const screen = useSelector(state => state.app.screen);

  if (SCREENS_WITHOUT_WORLD.includes(screen)) return null;

  return <Loading loading={worldLoading} />;
};

export default GlobalLoadingOverlay;
